import { useAuth0 } from "@auth0/auth0-react";

export default function Register() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <button
        onClick={() =>
          loginWithRedirect({
            authorizationParams: {
              screen_hint: "signup",
            },
          })
        }
        className="px-6 py-3 rounded-lg bg-green-600 text-white"
      >
        Register
      </button>
    </div>
  );
}
